// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import CurrencyInputController from "./currency_input_controller"
application.register("currency-input", CurrencyInputController)

import FacebookPixelController from "./facebook_pixel_controller"
application.register("facebook-pixel", FacebookPixelController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LoadingOverlayController from "./loading_overlay_controller"
application.register("loading-overlay", LoadingOverlayController)

import PartnerToggleController from "./partner_toggle_controller"
application.register("partner-toggle", PartnerToggleController)

import PostalLookupController from "./postal_lookup_controller"
application.register("postal-lookup", PostalLookupController)

import RecalculateNotifyController from "./recalculate_notify_controller"
application.register("recalculate-notify", RecalculateNotifyController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SyntaxHighlightController from "./syntax_highlight_controller"
application.register("syntax-highlight", SyntaxHighlightController)

import TagifyController from "./tagify_controller"
application.register("tagify", TagifyController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import TocHighlightController from "./toc_highlight_controller"
application.register("toc-highlight", TocHighlightController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
